//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getPathOptions, getwxacode } from '@/api/miniProgramManagement.js';

let PROD_QR_KEY = 'PROD_QR_MP';
export default {
  data() {
    return {
      queryAppid: '',
      qrCodeDialogVisible: false,
      pathOptions: [], // 二维码路径地址
      qrCodeFormData: {
        path: '',
      },
      pathValue: '',
      parameter: '',
      qcodeVisible: false,
      url: '',
      type: '', // type => 4 正式版正式环境
      dialogTitle: '体验版本二维码',
      qrLoading: false,
    };
  },
  created() {
    this.queryAppid = this.$route.query.appid;
    PROD_QR_KEY = `PROD_QR_MP_${this.queryAppid}`;
    this.getPath();
  },
  methods: {
    opencode(rowData) {
      this.type = rowData.type;
      if (this.type === '4') {
        this.dialogTitle = '正式版本二维码';
        this.handleQcode();
      } else if (this.type === '5') {
        // 小程序助手入口
        this.dialogTitle = '小程序助手';
        this.qcodeVisible = true;
        this.url = 'https://res.wx.qq.com/wxdoc/dist/assets/img/mydev-qrcode-new.669a7d88.jpg';
      } else {
        this.dialogTitle = '体验版本二维码';
        this.qrCodeDialogVisible = true;
      }
    },
    // 获取页面路径选项
    getPath() {
      getPathOptions({ appid: this.queryAppid, path: '/wxa/get_page', method: 'GET' })
        .then((data) => {
          const res = JSON.parse(data?.body || '{}');
          console.log('页面路径选项', res);
          let { page_list: pageList } = res;
          pageList = [...new Set(pageList)];
          const list = [];
          pageList.forEach((item, index) => {
            list.push({
              label: item,
              value: item,
              key: index,
            });
          });
          this.pathOptions = list;
        })
        .catch((err) => {
          this.$message(err.errmsg);
        });
    },
    // 二维码设置
    async handleQcode() {
      this.qrCodeDialogVisible = false;
      const path = `${this.pathValue}${this.parameter}`;
      const newPath = encodeURIComponent(path || this.pathOptions?.[0]?.value || '');
      console.log(newPath, this.type);
      this.qcodeVisible = true;
      if (this.type === '4') {
        try {
          const prodUrl = localStorage.getItem(PROD_QR_KEY);
          if (!prodUrl) {
            this.qrLoading = true;
            const datas = await getwxacode({
              appid: this.queryAppid,
              path: '/wxa/getwxacode',
              content_type: 'image/jpeg',
              body: JSON.stringify({ path: this.pathOptions?.[0]?.value || '' }),
            });
            const url = `data:image/jpeg;base64,${datas?.body || ''}`;
            const isImage = await this.isImage(url);
            if (isImage) {
              this.url = url;
              // 需要本地缓存，该二维码只能一共获取100000次
              localStorage.setItem(PROD_QR_KEY, this.url);
            } else {
              this.$message.error('加载图片失败，请稍后重试');
            }
            this.qrLoading = false;
          } else {
            this.url = prodUrl;
          }
        } catch (err) {
          console.log(err);
          this.qrLoading = false;
          this.$message.error(err.errmsg);
        }
      } else {
        const datas = await getwxacode({
          appid: this.queryAppid,
          path: '/wxa/get_qrcode',
          method: 'GET',
          query: JSON.stringify({ path: newPath }),
        });
        const url = `data:image/jpeg;base64,${datas?.body || ''}`;
        const isImage = await this.isImage(url);
        if (isImage) {
          this.url = url;
        } else {
          this.$message.error('加载图片失败，请稍后重试');
        }
      }
    },
    arrayBufferToBase64(buffer) {
      let binary = '';
      const bytes = new Uint8Array(buffer);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    },
    async isImage(url) {
      return new Promise((re) => {
        let image = new Image();
        const clearVar = () => {
          image.onload = null;
          image.onerror = null;
          image = null;
        };
        image.onload = () => {
          re(true);
          clearVar();
        };
        image.onerror = () => {
          re(false);
          clearVar();
        };
        image.src = url;
      });
    },
    close() {
      this.url = '';
      this.qcodeVisible = false;
    },
  },
};
